import { DEFAULT_WHITELISTED_TAGS, ALL_HTML_TAG_REGEX } from 'Src/constants'
import { domPurifySpecifiedTagsAndRemoveContent } from 'Utils/dom-purify'

export const getSanitisedHtmlObj = (htmlString, defaultTagsToRemove) => {
  const santisedHtmlString = domPurifySpecifiedTagsAndRemoveContent(htmlString, defaultTagsToRemove)
  return { __html: santisedHtmlString } // obj for dangerouslySetInnerHTML method
}

export const hasNonWhitelistedTags = (html = '', whitelistedTags = DEFAULT_WHITELISTED_TAGS) => {
  const allTagsWithAttributes = html.match(ALL_HTML_TAG_REGEX) || []
  const allTags = allTagsWithAttributes.map((tag) => tag.split(' ')[0].replace(/<\/*|\/*>/g, '')) // remove < or </ or /> or > and attributes
  const uniqueTags = [...new Set(allTags)]
  return uniqueTags.some((tag) => !whitelistedTags.includes(tag))
}

export const hasHtmlContent = (html = '') => {
  return !!html.match(ALL_HTML_TAG_REGEX)
}
